import React from "react";
import "./../../styles/pages/CustomPage.css";
import cathedralImage from "../../assets/catedral_rosas.jpg";
import futbolImage from "../../assets/cultural.jpg";
import campoImage from "../../assets/campo.jpg";
import classImage from "../../assets/clase.jpg";
import { Link } from "react-router-dom";

const ActivitiesPage = () => {
  return (
    <div className="msf-container">
      {/* Fila superior: Texto a la izquierda, imagen a la derecha */}
      <div className="msf-row reverse">
        <div className="msf-text">
          <h2 className="custom-page-h2">El Camino de Santiago</h2>
          <div className="red-line"></div>
          <p>
            El Camino de Santiago es una travesía milenaria que discurre por
            distintas regiones de España, y que se ha convertido en un símbolo
            de esfuerzo, espiritualidad y superación. Existen varias rutas que
            conducen hasta Santiago de Compostela, cada una con su origen y
            particularidades. Entre las más conocidas se encuentran el Camino
            Francés, que parte desde los Pirineos, y el Camino Portugués, que
            recorre la costa atlántica.
          </p>
          <p>
            Proyecto Chicas Rosas organiza cada año una experiencia única en el
            Camino de Santiago. Esta iniciativa está dirigida a personas que han
            padecido o están padeciendo cáncer de mama, y tiene como objetivo
            fomentar el ejercicio físico, la superación personal y el apoyo
            mutuo.
          </p>
          <p>
            Los diferentes itinerarios del Camino han llevado a las Chicas Rosas
            desde el 2016 a través de paisajes que van desde Sarria a Santiago,
            pasando por Fisterra-Muxía, el Camino Lebaniego, el Camino Sanabrés,
            el Camino Portugués y en 2023 el Camino Inglés. Cada una de estas
            rutas ofrece un contexto único, lleno de belleza natural, historia y
            cultura, que enriquece la experiencia para todas las participantes.
          </p>
        </div>
        <div className="msf-image msf-image-first">
          <div className="msf-next-edition">
            <h3 className="pink">Próxima edición</h3>
            <p>
              La próxima edición se realizará en{" "}
              <span className="msf-underline">junio de 2026</span> y
              recorreremos la Variante Espiritual del Camino Portugués. Para leer toda la
              información disponible dirígete a la sección{" "}
              <Link
                to="/proxima-edicion-camino"
                style={{ color: "blue", textDecoration: "underline" }}
              >
                Camino Santiago 2026
              </Link>{" "}
              .
            </p>
          </div>
          <img src={cathedralImage} alt="Medical assistance worldwide" />
        </div>
      </div>
      {/* Fila inferior: Imagen a la izquierda, texto a la derecha */}
      <div className="msf-row msf-row-image-first">
        <div className="msf-image">
          <img src={campoImage} alt="Medical care in action" />
        </div>
        <div className="msf-text">
          <h2 className="custom-page-h2">Rutas Rosas y de entrenamiento</h2>
          <div className="red-line"></div>
          <p>
            Las Rutas la constituyen dos tipos, unas de entrenamiento y las
            rutas rosas, de menor recorrido y cercanas a la ciudad de Sevilla.
            Salvo el trimestre veraniego, el resto del año se planifican cada
            dos semanas rutas de entrenamiento de aproximadamente 12-16 km, por
            distintos emplazamientos en los pueblos cercanos a la capital de
            Sevilla. El objetivo es caminar en grupo por terrenos más similares
            a los gallegos con el objetivo de entrenar, pero sobre todo como
            punto de encuentro, y que sirva de incentivo. Se realizan los
            sábados y la duración suele ser de unos cuatros horas. Tras el
            camino comemos en grupos facilitando la comunicación y nuestras
            reflexiones.
          </p>
          <p>
            Las rutas rosas son otro formato enfocado a mujeres que por la
            situación personal consideran hacer ejercicio físico, pero de menor
            impacto. Son rutas más cercanas a la capital y de menor recorrido y
            dificultad de unas dos horas de duración. Se alternan ambos tipos de
            rutas a lo largo de las semanas.
          </p>
          <p>
            Las rutas las consideramos un punto de encuentro, siendo necesario
            la actividad individual diaria de cada uno, pues ese es el objetivo.
          </p>
        </div>
      </div>
      {/* Nueva sección: Charlas de formación e información */}
      <div className="msf-row reverse">
        <div className="msf-text">
          <h2 className="custom-page-h2">Charlas de formación e información</h2>
          <div className="red-line"></div>
          <p>
            Se realizan con la colaboración de profesionales de diferentes
            ámbitos: farmacéuticos, nutricionistas, profesionales especializados
            en deporte, ginecólogos, psicólogos, trabajadores sociales…
          </p>
          <p>Colaboran profesionales adscritos a la asociación:</p>
          <ul>
            <li>Doña Concepción Perez Colchero, Licenciada en Psicología</li>
            <li>Doña Caridad Ortega García, Médico Rehabilitadora</li>
            <li>Doña Inmaculada Arboleda Romero, Médico Rehabilitadora</li>
          </ul>
          <p>
            Son habituales las invitaciones de la Real Academia de Medicina y
            Cirugía de Sevilla a las ponencias con la temática de la asociación.
          </p>
        </div>
        <div className="msf-image msf-image-first">
          <img src={classImage} alt="Medical assistance worldwide" />
        </div>
      </div>

      {/* Nueva sección: Otras actividades */}
      <div className="msf-row msf-row-image-first">
        <div className="msf-image">
          <img src={futbolImage} alt="Medical care in action" />
        </div>
        <div className="msf-text">
          <h2 className="custom-page-h2">Otras actividades</h2>
          <div className="red-line"></div>
          <h3>Actividades solidarias</h3>
          <p>
            Colaboración con otras asociaciones como Andalucía por un Mundo
            Nuevo y Friend of Haiti in NY. Y con la obra social de la Parroquia
            San Pio en Sevilla.
          </p>
          <p>
            Organizando conciertos solidarios a favor de la investigación en
            colaboración con entidades públicas y grupos musicales amateur.
          </p>
          <h3>Actividades culturales</h3>
          <p>
            Organizar visitas culturales es otra actividad de la Asociación.
          </p>
          <p>
            Aunar ocio, aprendizaje y cultura es una forma muy atractiva de
            socializar y cohesionar a las socias y socios.
          </p>
        </div>
      </div>
      <div className="msf-solidarity">
        <h3 className="pink">Unidos por la solidaridad</h3>
        <p>
          En octubre de 2024, fuimos el destino de un gesto de solidaridad. La
          dirección del <strong>Club de Fútbol La Moneda</strong> de Dos
          Hermanas anunció la donación de la recaudación obtenida por la venta
          de <strong>100 camisetas</strong> conmemorativas en apoyo a la lucha
          contra el cáncer de mama.
        </p>
        <p>
          Queremos expresar nuestro más sincero agradecimiento a todos los que
          hicieron posible esta iniciativa: Miguel, Rafael y a cada persona que
          contribuyó con su apoyo.
        </p>

        <p>¡Gracias por formar parte de esta causa!</p>
      </div>
    </div>
  );
};

export default ActivitiesPage;
